import apiService from 'src/shared/config/apiService';
import { BulkOrdering } from 'src/shared/types/bulkOrdering';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

const getBulkOrderings = async (productId: string): Promise<BulkOrdering[]> => {
  try {
    const response = await apiService.get(
      `/products/${productId}/bulk_orders/`
    );

    return response.data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export default getBulkOrderings;
